export default __webpack_public_path__ + "static/about-image-a0311f818fafac15eaec92cbf48adc13.png";